import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAssistanceItem } from '../../api/assistance/assistance';

export type AssistanceStateType = {
  activeAssistances: { [key: string]: IAssistanceItem };
};

const initialState: AssistanceStateType = {
  activeAssistances: {},
};

const assistanceSlice = createSlice({
  name: 'assistance',
  initialState,
  reducers: {
    manageActiveAssistances(state, action: PayloadAction<{ assistances: IAssistanceItem[] }>) {
      const currentActives: AssistanceStateType['activeAssistances'] = action.payload.assistances
        .filter((assistance) => !!assistance.activa)
        .reduce((pv, cv) => ({ ...pv, [cv.identificador]: { ...cv } }), {});
      // const currentActiveKeys = Object.keys(currentActives);
      // const oldActives = Object.keys(state.activeAssistances);
      // for (const oldAssistance of oldActives) {
      //   if (!currentActiveKeys.includes(oldAssistance) && state.activeAssistances?.[oldAssistance]) {
      //     state.activeAssistances[oldAssistance].activa = false;
      //   }
      // }
      state.activeAssistances = { ...state.activeAssistances, ...currentActives };
    },
    deleteActiveAssistance(state, action: PayloadAction<{ identifier: string }>) {
      if (state.activeAssistances[action?.payload?.identifier]) {
        delete state.activeAssistances[action?.payload?.identifier];
      }
    },
  },
});

export const { manageActiveAssistances, deleteActiveAssistance } = assistanceSlice.actions;

export default assistanceSlice.reducer;
